<div *ngIf="value !== undefined" class="label-container">
  <p>
    Starting From: <span class="price-value">{{ value }}</span>
  </p>
</div>
